"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.brandLogos = void 0;
const basic_1 = require("../basic");
exports.brandLogos = (0, basic_1.applyBase)({
    items: {
        px: [2, 2, 0],
        pb: [2, 0],
        mb: [3, 4, 0],
        '@media (max-width: 1335px)': {
            ml: 'auto',
            mr: 0,
            width: [null, 'calc(50% - 24px)'],
        },
    },
    imageLink: {
        padding: basic_1.basic.space[1],
        '&:not(:last-child)': {
            marginRight: basic_1.basic.space[3],
            [basic_1.basic.media.tablet]: {
                marginRight: '40px',
            },
        },
    },
});
//# sourceMappingURL=brand-logos.js.map